(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-az-header]');
    if (!header) return;

    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 12) {
        header.classList.add('is-stuck');
      } else {
        header.classList.remove('is-stuck');
      }
      lastY = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const details = header.querySelector('.az-header__mobile-menu');
    const closeButton = header.querySelector('.az-header__drawer-close');
    const backdrop = header.querySelector('.az-header__drawer-backdrop');
    const drawerLinks = header.querySelectorAll('.az-header__drawer a');
    const searchDetails = header.querySelector('.header__search details');
    const searchInput = header.querySelector('#Az-Search-Modal');
    const body = document.body;
    let lockedScrollY = 0;
    let shouldRestoreScroll = false;

    if (searchDetails && searchInput) {
      searchDetails.addEventListener('toggle', () => {
        if (searchDetails.open) {
          requestAnimationFrame(() => searchInput.focus());
        }
      });
    }

    if (!details || !closeButton || !backdrop) return;

    const syncMobileMenuState = () => {
      if (details.open) {
        lockedScrollY = window.scrollY;
        shouldRestoreScroll = true;
        body.classList.add('az-mobile-menu-open');
        body.style.setProperty('--az-scroll-lock-top', `${-lockedScrollY}px`);
      } else {
        body.classList.remove('az-mobile-menu-open');
        body.style.removeProperty('--az-scroll-lock-top');
        if (shouldRestoreScroll) {
          window.scrollTo(0, lockedScrollY);
          shouldRestoreScroll = false;
        }
      }
    };

    details.addEventListener('toggle', syncMobileMenuState);
    syncMobileMenuState();

    closeButton.addEventListener('click', () => {
      details.removeAttribute('open');
    });

    backdrop.addEventListener('click', () => {
      details.removeAttribute('open');
    });

    drawerLinks.forEach((link) => {
      link.addEventListener('click', () => {
        details.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
